<template>
  <div class="h-full flex relative">
    <el-card class="h-full mr-10px w-300px" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">组件名称</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
        <el-button size="small" type="primary" @click="$refs.componentTree.filter(treeKeyword)">
          搜索
        </el-button>
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="componentTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="h-[calc(100%-84px)] overflow-auto"
        :props="{
          children: 'child',
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
      >
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <el-input
          v-model="search.title"
          size="small"
          placeholder="标题名称"
          class="w-180px mr-10px"
          clearable
        ></el-input>
        <div>
          <el-button type="primary" size="small" @click="searchData">
            搜索
          </el-button>
          <el-button size="small" @click="reset">重置</el-button>
          <el-button
            type="primary"
            :disabled="!currentNode.id || disabledOperation('add')"
            size="small"
            @click="
              operateBtn(
                {
                  intevalValue: 1,
                },
                'create'
              )
            "
          >
            新增
          </el-button>
          <el-button
            type="danger"
            :disabled="selectedList.length === 0 || disabledOperation('delete')"
            size="small"
            @click="deleteData({}, false)"
          >
            删除
          </el-button>
        </div>
      </div>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        class="mt-20px"
        height="calc(100% - 104px)"
        ref="tableRef"
        :row-key="(record) => record.id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="标题名称" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column label="置顶等级" prop="sort" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              size="small"
              v-model="scope.row.sort"
              :disabled="disabledOperation('top')"
              class="w-full"
              @change="switchTop($event, scope.row)"
            >
              <el-option
                v-for="item in topList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="发布人"
          prop="creatorName"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否显示" prop="isEnable" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isShow"
              :disabled="disabledOperation('show')"
              @change="switchShow($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="发布时间"
          prop="creationTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'look')">
              查看
            </el-button>
            <el-button
              size="mini"
              @click="operateBtn(scope.row, 'update')"
              :disabled="disabledOperation('edit')"
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              @click="deleteData(scope.row, true)"
              :disabled="disabledOperation('delete')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.total"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>
    </el-card>
    <addEdit
      class="absolute top-0 left-0 z-100 h-full w-full"
      @close="closeGathetTaskDig"
      @on-success="handleSaveSuccess"
      v-if="showAddEditDialog"
      :treeData="treeData"
      :title="operateTitle"
      :operateType="operateType"
      :detailData="detailData"
      :currentNode="currentNode"
    ></addEdit>
  </div>
</template>
<script>
import { ColumApi, ColumnTableApi, ColumnRightsApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import { informationPublishMap } from '../../../js/config'

const componentTypes = informationPublishMap.component
const BANNERVAL = componentTypes.banner
const WINDOWNVAL = componentTypes.popup
const CAROUSEVAL = componentTypes.carouse
const TOPICVAL = componentTypes.topic
const LINKVAL = componentTypes.hyperlink

const columApi = new ColumApi()
const columnTableApi = new ColumnTableApi()

const columnRightsApi = new ColumnRightsApi()
const addEdit = () => {
  return import('./AddEditDialog')
}
export default {
  name: 'componentPublishManagement',
  components: { addEdit },
  data() {
    return {
      linkVal: LINKVAL,
      search: {
        title: '',
        isEnable: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [],
      tableData: [],
      treeKeyword: '',
      // 默认展开
      defaultExpandIds: [''],
      // 分类树显隐
      treeStandBy: true,
      // 是否默认展开全部
      defaultExpandAll: false,
      treeLoading: false,
      tableLoading: false,
      currentNodeKey: '',
      selectedList: [],
      showAddEditDialog: false,
      operateType: true,
      operateTitle: '',
      detailData: {},
      currentNode: '',
      columnPermission: [],
      topList: [
        { label: '不置顶', value: 0 },
        { label: '置顶1', value: 5 },
        { label: '置顶2', value: 4 },
        { label: '置顶3', value: 3 },
        { label: '置顶4', value: 2 },
        { label: '置顶5', value: 1 },
      ],
    }
  },
  created() {
    this.getTreeData()
  },
  computed: {},
  methods: {
    searchData() {
      this.page.pageNo = 1
      this.getList()
      this.$refs.tableRef && this.$refs.tableRef.clearSelection()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchData()
    },
    async getPermission(data) {
      const [err, res] = await columnRightsApi.getColumnRight({
        columnId: data.id,
      })
      if (!err) {
        this.columnPermission = JSON.parse(res)
      }
    },
    operateBtn(row, type) {
      this.detailData = row
      switch (type) {
        case 'create':
          this.operateTitle = `新增${this.currentNode.name}组件发布`
          this.operateType = true
          break
        case 'update':
          this.operateTitle = `编辑${this.currentNode.name}组件发布`
          this.operateType = true
          break
        case 'look':
          this.operateTitle = `${this.currentNode.name}组件发布详情`
          this.operateType = false
          break
        default:
          break
      }
      this.showAddEditDialog = true
    },
    deleteData(row, type) {
      let ids = [] // 删除项的id集合
      if (!type) {
        // 删除勾选
        if (!this.selectedList.length) {
          this.$message.warning('请先勾选要删除的数据项')
          return
        }
        ids = _.map(this.selectedList, 'id')
      } else {
        ids = [row.id]
      }
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const params = {
            body: ids,
          }
          let err
          // 超链接类型
          if (this.currentNode.type === this.linkVal) {
            ;[err] = await columnTableApi.deleteLinkColumnTable(params)
          } else {
            ;[err] = await columnTableApi.deleteBinnerColumnTable(params)
          }
          if (!err) {
            this.$message.success('删除成功')
            this.$refs.tableRef && this.$refs.tableRef.clearSelection()
            this.searchData()
          }
        })
        .catch(() => {})
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(1, {
        isOnlyShowOwnRight: true,
      })
      if (!err) {
        const types = [BANNERVAL, WINDOWNVAL, CAROUSEVAL, TOPICVAL, LINKVAL]
        // 只有五种类型的需要发布
        const list = res.filter((item) => {
          if (types.includes(item.type)) {
            return item
          }
          return null
        })
        this.treeData = list
        if (list.length) {
          this.currentNode = list[0]
          this.handleNodeClick(this.currentNode)
          this.$nextTick(() => {
            this.$refs.componentTree.setCurrentKey(this.currentNode.id)
          })
        }
      }
    },
    // 是否置顶的切换
    async switchTop(event, row) {
      const params = {
        body: {
          ...row,
          sort: event,
          lastModificationTime: null,
        },
        header: {
          'wiz-sensitive-words': false,
        },
      }
      let apiRes = null
      // 1 = 栏目为文字类型
      if (this.currentNode.type === this.linkVal) {
        apiRes = await columnTableApi.updateLinkColumnTable(params)
      } else {
        apiRes = await columnTableApi.updateBinnerColumnTable(params)
      }
      if (!apiRes[0]) {
        this.$message.success('操作成功')
        this.getList()
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      }
    },
    async getList() {
      const params = {
        title: this.search.title,
        columnId: this.currentNode && this.currentNode.id,
        header: {
          'wiz-sensitive-words': false,
        },
      }
      this.tableLoading = true
      let err
      let res
      // 5 = 组件为超链接类型
      if (this.currentNode.type === this.linkVal) {
        ;[err, res] = await columnTableApi.getLinkColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      } else {
        // 非超链接的其它四项为同一个接口
        ;[err, res] = await columnTableApi.getBinnerColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      }
      if (!err) {
        this.tableData =
          res &&
          res.items &&
          res.items.map((it) => {
            it.creationTime = dayjs(it.creationTime).format('YYYY-MM-DD HH:mm:ss')
            return it
          })
        this.page.total = res && res.totalCount
      }
      this.tableLoading = false
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    handleNodeClick(node) {
      this.page.pageNo = 1
      this.currentNode = node
      this.getList()
      this.getPermission(node)
    },
    handleSelectionChange(list) {
      this.selectedList = list
    },
    closeGathetTaskDig() {
      this.showAddEditDialog = false
    },
    handleSaveSuccess() {
      this.showAddEditDialog = false
      this.getList()
    },
    // 是否显示的切换
    async switchShow(event, row) {
      const params = {
        ...row,
        isShow: event,
        lastModificationTime: null,
      }
      let err
      // 1 = 栏目为文字类型
      if (this.currentNode.type === this.linkVal) {
        ;[err] = await columnTableApi.updateLinkColumnTable({ body: params })
      } else {
        ;[err] = await columnTableApi.updateBinnerColumnTable({ body: params })
      }
      if (!err) {
        this.$message.success('操作成功')
        this.getList()
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      }
    },
    disabledOperation(string) {
      return !_.includes(this.columnPermission, string)
    },
  },
}
</script>
<style scoped lang="scss"></style>
